import React, {FC} from "react";
import {Form, Input, Radio, Typography} from "antd";
import {requiredPhoneRules, requiredTextRules} from "./formRules";
import {useRegistrationCopy} from "./registrationCopy";
import {buildPayerTypeOptions, requiresCompanyStylePayerFields} from "./types";
import type {PayerTypeValue} from "./types";

// Payer type plus only the payer fields that type needs.
export const PayerFields: FC<{payerType: PayerTypeValue}> = ({payerType}) => {
    const {labels} = useRegistrationCopy();
    const companyStylePayerFieldsRequired = requiresCompanyStylePayerFields(payerType);
    const descriptions = [
        labels.individualPayerDescription,
        labels.companyPayerDescription,
        labels.sponsoredPayerDescription
    ];
    const payerTypeOptions = buildPayerTypeOptions(labels)
        .map((option, index) => ({...option, description: descriptions[index]}));

    return (
        <>
            <Form.Item
                name="payerType"
                label={labels.payerType}
                rules={[{required: true, message: labels.required}]}
            >
                <Radio.Group className="public-registration-choice-list">
                    {payerTypeOptions.map(option => (
                        <Radio key={option.value} value={option.value}>
                            <span className="public-registration-choice-copy">
                                <span>{option.label}</span>
                                <Typography.Text type="secondary">{option.description}</Typography.Text>
                            </span>
                        </Radio>
                    ))}
                </Radio.Group>
            </Form.Item>

            <div className="public-registration-form-grid">
                {companyStylePayerFieldsRequired ? (
                    <>
                        <Form.Item name="payerName" label={labels.payerName} rules={requiredTextRules(labels)}>
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            name="payerEmail"
                            label={labels.payerEmail}
                            rules={[
                                ...requiredTextRules(labels),
                                {type: "email", message: labels.invalidEmail}
                            ]}
                        >
                            <Input type="email"/>
                        </Form.Item>
                        <Form.Item name="payerPhone" label={labels.payerPhone} rules={requiredPhoneRules(labels)}>
                            <Input type="tel"/>
                        </Form.Item>
                    </>
                ) : null}
                <Form.Item name="payerTaxId" label={labels.payerTaxId} rules={requiredTextRules(labels)}>
                    <Input/>
                </Form.Item>
                <Form.Item name="payerAddress" label={labels.payerAddress} rules={requiredTextRules(labels)}>
                    <Input/>
                </Form.Item>
                <Form.Item name="payerCity" label={labels.payerCity} rules={requiredTextRules(labels)}>
                    <Input/>
                </Form.Item>
                <Form.Item name="payerCountry" label={labels.payerCountry} rules={requiredTextRules(labels)}>
                    <Input/>
                </Form.Item>
                {companyStylePayerFieldsRequired ? (
                    <Form.Item name="payerContactPerson" label={labels.payerContactPerson} rules={requiredTextRules(labels)}>
                        <Input/>
                    </Form.Item>
                ) : null}
            </div>
        </>
    );
};
